import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.lpsysadmin.collab.board.item');
import { OnInit, Input, OnChanges } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-lpsysadmin-collab-board-item',
template: templateSource || '',
    styles: [`

/* file: /opt/app/project/main/build/src/app/portal.lpsysadmin.collab.board.item/view.scss */
:host {
  display: block;
  height: 100%;
}

.markdown-body {
  white-space: pre-wrap;
  word-break: break-word;
  line-height: 1.7;
  color: #18181b;
}`],
})
export class PortalLpsysadminCollabBoardItemComponent implements OnInit, OnChanges {
    @Input() workspace_id: string = '';
    @Input() post_id: string = '';

    constructor(@Inject( Service) public service: Service) { }

    public post: any = null;
    public workspace: any = null;
    public role: string = '';
    public canEdit: boolean = false;
    public comments: any[] = [];
    public reactions: any = { post: {}, comment: {} };
    public readers: any[] = [];
    public loaded: boolean = false;

    public newComment: string = '';
    public replyTo: any = null;
    public editMode: boolean = false;
    public editPost: any = {};

    public emojis: string[] = ['👍', '❤️', '🎉', '😄', '🤔', '🚀'];

    public ngOnChanges() {
        if (this.workspace_id && this.post_id) this.load();
    }

    public async ngOnInit() {
        await this.service.init();
        if (this.workspace_id && this.post_id) await this.load();
    }

    public async load() {
        const res = await wiz.call('init', { workspace_id: this.workspace_id, post_id: this.post_id });
        if (res.code !== 200) {
            this.service.alert.error(res.data?.message || '게시글을 불러올 수 없습니다.');
            this.service.href(`/admin/collab/board/${this.workspace_id}`);
            return;
        }
        this.post = res.data.post;
        this.workspace = res.data.workspace;
        this.role = res.data.role;
        this.canEdit = res.data.can_edit;
        this.comments = res.data.comments || [];
        this.reactions = res.data.reactions || { post: {}, comment: {} };
        this.readers = res.data.readers || [];
        this.loaded = true;
        await this.service.render();
    }

    public back() {
        this.service.href(`/admin/collab/board/${this.workspace_id}`);
    }

    public async togglePin() {
        const res = await wiz.call('pin', { post_id: this.post_id });
        if (res.code === 200) {
            this.post.pinned = res.data.pinned;
            await this.service.render();
        } else {
            this.service.alert.error(res.data?.message || '실패');
        }
    }

    public startEdit() {
        this.editMode = true;
        this.editPost = {
            title: this.post.title,
            content: this.post.content,
            category: this.post.category,
            pinned: this.post.pinned,
        };
    }

    public cancelEdit() {
        this.editMode = false;
    }

    public async saveEdit() {
        if (!this.editPost.title?.trim()) {
            this.service.alert.error('제목을 입력하세요.');
            return;
        }
        const res = await wiz.call('update', {
            post_id: this.post_id,
            title: this.editPost.title,
            content: this.editPost.content,
            category: this.editPost.category,
            pinned: this.editPost.pinned ? '1' : '',
        });
        if (res.code === 200) {
            this.editMode = false;
            await this.load();
        } else {
            this.service.alert.error(res.data?.message || '저장 실패');
        }
    }

    public async remove() {
        if (!confirm('게시글을 삭제하시겠습니까?')) return;
        const res = await wiz.call('delete', { post_id: this.post_id });
        if (res.code === 200) {
            this.back();
        } else {
            this.service.alert.error(res.data?.message || '삭제 실패');
        }
    }

    public async addComment() {
        const text = (this.newComment || '').trim();
        if (!text) return;
        const res = await wiz.call('comment_add', {
            post_id: this.post_id,
            content: text,
            parent_id: this.replyTo?.id || '',
        });
        if (res.code === 200) {
            this.newComment = '';
            this.replyTo = null;
            await this.load();
        } else {
            this.service.alert.error(res.data?.message || '댓글 등록 실패');
        }
    }

    public async deleteComment(c: any) {
        if (!confirm('댓글을 삭제하시겠습니까?')) return;
        const res = await wiz.call('comment_delete', { comment_id: c.id });
        if (res.code === 200) {
            await this.load();
        }
    }

    public setReply(c: any) {
        this.replyTo = c;
    }

    public cancelReply() {
        this.replyTo = null;
    }

    public async toggleReaction(emoji: string, comment_id: string = '') {
        const res = await wiz.call('react', { post_id: this.post_id, emoji, comment_id });
        if (res.code === 200) await this.load();
    }

    public reactionEntries(target: string, key: string = ''): any[] {
        const src = target === 'comment' ? (this.reactions?.comment?.[key] || {}) : (this.reactions?.post || {});
        return Object.entries(src).map(([emoji, info]: any) => ({ emoji, count: info.count, users: info.users }));
    }

    public async vote(option_key: string) {
        if (!this.post?.poll || this.post.poll.closed) return;
        const multi = this.post.poll.multi;
        let keys: string[] = [];
        if (multi) {
            const current = this.myVotes();
            if (current.includes(option_key)) {
                keys = current.filter((k: string) => k !== option_key);
            } else {
                keys = [...current, option_key];
            }
        } else {
            keys = [option_key];
        }
        const res = await wiz.call('poll_vote', { post_id: this.post_id, options: JSON.stringify(keys) });
        if (res.code === 200) await this.load();
    }

    public myVotes(): string[] {
        const opts = this.post?.poll?.options || [];
        return opts.filter((o: any) => (o.votes || []).includes(this.service.auth?.session?.id || '')).map((o: any) => o.key);
    }

    public hasVoted(option_key: string): boolean {
        return this.myVotes().includes(option_key);
    }

    public pollTotal(): number {
        const opts = this.post?.poll?.options || [];
        const seen = new Set<string>();
        opts.forEach((o: any) => (o.votes || []).forEach((u: string) => seen.add(u)));
        return seen.size;
    }

    public pollPercent(option: any): number {
        const total = this.pollTotal();
        if (!total) return 0;
        return Math.round(((option.votes || []).length / total) * 100);
    }

    public async closePoll() {
        if (!confirm('투표를 마감하시겠습니까?')) return;
        const res = await wiz.call('poll_close', { post_id: this.post_id });
        if (res.code === 200) await this.load();
    }

    public categoryLabel(c: string): string {
        return c === 'notice' ? '공지' : c === 'poll' ? '투표' : '일반';
    }

    public categoryColor(c: string): string {
        if (c === 'notice') return 'bg-rose-100 text-rose-700 ring-1 ring-rose-200';
        if (c === 'poll') return 'bg-violet-100 text-violet-700 ring-1 ring-violet-200';
        return 'bg-zinc-100 text-zinc-700 ring-1 ring-zinc-200';
    }

    public formatDateTime(d: any): string {
        if (!d) return '';
        const dt = new Date(d);
        const y = dt.getFullYear();
        const m = String(dt.getMonth() + 1).padStart(2, '0');
        const day = String(dt.getDate()).padStart(2, '0');
        const hh = String(dt.getHours()).padStart(2, '0');
        const mm = String(dt.getMinutes()).padStart(2, '0');
        return `${y}-${m}-${day} ${hh}:${mm}`;
    }

    public threaded(): any[] {
        const roots: any[] = [];
        const map: any = {};
        this.comments.forEach(c => { map[c.id] = { ...c, children: [] }; });
        this.comments.forEach(c => {
            if (c.parent_id && map[c.parent_id]) {
                map[c.parent_id].children.push(map[c.id]);
            } else {
                roots.push(map[c.id]);
            }
        });
        return roots;
    }
}

export default PortalLpsysadminCollabBoardItemComponent;